import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/dashboard/Dashboard'
// import ChartOfAccount from '../views/chartOfAccount/ChartOfAccount'
// import DashboardThree from '../views/template/dashboards/DashboardThree'
// import DashboardFour from '../views/template/dashboards/DashboardFour'
import Logon from '../views/auth/Logon'
import Register from '../views/auth/Register'
import Forgot from '../views/auth/Forgot'
import CompanyList from "../views/company/CompanyList";
import Details from "../views/company/Details";
import Officers from "../views/officer/Officers";
import NewOfficer from "../views/officer/NewOfficer";
import OfficerDetails from "../views/officer/OfficerDetails";
import CreateUser from "../views/cbank/CreateUser";
import SubmitDispute from "../views/dispute/SubmitDispute";
import Disputes from "../views/dispute/Disputes";
import FtLogs from "../views/developer/FtLogs";
import NeLogs from "../views/developer/NeLogs";
import Settings from "../views/developer/Settings";
import ApiDocumentation from "../views/developer/ApiDocumentation";
import Documents from "../views/company/Documents";
import PersonalProfile from "../views/profile/PersonalProfile";
import OfficerProfile from "../views/profile/OfficerProfile";
import OfficerReg from "../views/officer/OfficerReg";
import CreateCompany from "../views/company/CreateCompany";
import Metrics from "../views/developer/Metrics";
import Wallets from "../views/developer/Wallets";
import WalletsTransactions from "../views/developer/WalletsTransactions";
import TwoFa from "../views/auth/TwoFa";
import WalletAccounts from "../views/developer/WalletAccounts";

Vue.use(VueRouter);

VueRouter.prototype.absUrl = function(url, newTab = true) {
    const link = document.createElement('a')
    link.href = url
    link.target = newTab ? '_blank' : ''
    if (newTab) link.rel = 'noopener noreferrer' // IMPORTANT to add this
    link.click()
}


const routes = [
    {
        path: '/dashboard',
        name: 'Dashboard',
        // meta: {layout: 'userpages'},
        component: Dashboard,
        meta: { authRequired: true},
    },
    {
        path: '/dashboard/details',
        name: 'Details',
        // meta: {layout: 'userpages'},
        component: Details,
        meta: { authRequired: true},
    },
    {
        path: '/officers',
        name: 'Officers',
        // meta: {layout: 'userpages'},
        component: Officers,
        meta: { authRequired: true},
    },
    {
        path: '/new-officer',
        name: 'NewOfficer',
        // meta: {layout: 'userpages'},
        component: NewOfficer,
        meta: { authRequired: true},
    },
    {
        path: '/officer-details',
        name: 'OfficerDetails',
        // meta: {layout: 'userpages'},
        component: OfficerDetails,
        meta: { authRequired: true},
    },
    {
        path: '/create-user',
        name: 'CreateUser',
        //meta: {layout: 'userpages'},
        component: CreateUser,
        meta: { authRequired: true},
    },
    {
        path: '/submit-dispute',
        name: 'SubmitDispute',
        // meta: {layout: 'userpages'},
        component: SubmitDispute,
        meta: { authRequired: true},
    },
    {
        path: '/disputes',
        name: 'DashboardFour',
        //meta: {layout: 'userpages'},
        component: Disputes,
        meta: { authRequired: true},
    },
    {
        path: '/transactions',
        name: 'FtLogs',
        //meta: {layout: 'userpages'},
        component: FtLogs,
        meta: { authRequired: true},
    },
    {
        path: '/name-enquiries',
        name: 'NeLogs',
        //meta: {layout: 'userpages'},
        component: NeLogs,
        meta: { authRequired: true},
    },
    {
        path: '/settings',
        name: 'Settings',
        //meta: {layout: 'userpages'},
        component: Settings,
        meta: { authRequired: true},
    },
    {
        path: '/api-documentation',
        name: 'ApiDocumentation',
        //meta: {layout: 'userpages'},
        component: ApiDocumentation,
        meta: { authRequired: true},
    },
    {
        path: '/documents',
        name: 'Documents',
        //meta: {layout: 'userpages'},
        component: Documents,
        meta: { authRequired: true},
    },
    {
        path: '/personal-profile',
        name: 'PersonalProfile',
        //meta: {layout: 'userpages'},
        component: PersonalProfile,
        meta: { authRequired: true},
    },
    {
        path: '/officer-profile',
        name: 'OfficerProfile',
        //meta: {layout: 'userpages'},
        component: OfficerProfile,
        meta: { authRequired: true},
    },
    {
        path: '/officer-reg-complete',
        name: 'OfficerReg',
        meta: {layout: 'auth', authRequired: false},
        component: OfficerReg,
    },
    {
        path: '/',
        name: 'Logon',
        meta: {layout: 'auth', authRequired: false},
        component: Logon,
    },
    {
        path: '/register',
        name: 'Register',
        meta: {layout: 'auth', authRequired: false},
        component: Register,
    },
    {
        path: '/forgot-password',
        name: 'Forgot',
        meta: {layout: 'auth', authRequired: false},
        component: Forgot,
    },
    {
        path: '/two-fa',
        name: 'TwoFa',
        meta: {layout: 'auth', authRequired: false},
        component: TwoFa,
    },
    {
        path: '/my-companies',
        name: 'Companies',
        meta: {layout: 'auth', authRequired: false},
        component: CompanyList,
    },
    {
        path: '/new-company',
        name: 'CreateCompany',
        meta: {layout: 'auth', authRequired: false},
        component: CreateCompany,
    },
    {
        path: '/developer-dashboard',
        name: 'Metrics',
        meta: {authRequired: true},
        component: Metrics,
    },
    {
        path: '/virtual-accounts',
        name: 'WalletAccounts',
        meta: { authRequired: true},
        component: WalletAccounts,
    },
    {
        path: '/virtual-transaction',
        name: 'WalletsTransactions',
        meta: {authRequired: true},
        component: WalletsTransactions,
    },
    {
        path: '/read-wallets',
        name: 'ReadWallets',
        meta: {authRequired: true},
        component: Wallets,
    }
];

// const router = new VueRouter({
//     mode: 'history',
//     base: process.env.BASE_URL,
//     routes
// });

export default routes

